module.exports = __webpack_public_path__ + "static/media/paint-brush.c0a5a87a.svg";